import SArray from 's-array';
import { Entrypoints } from 'core/app/entrypoints';
import { maybeLoader } from 'lib/maybeLoader';
import { PortFilterer } from './model';
import { HomePagePortInPortVesselsData } from 'data/models/HomePage';
import { IAjax } from 'lib/Ajax';
import TZDate from 'lib/TZDate';

export const InPortVessels = (ajax : IAjax, date : TZDate, portFilterer : PortFilterer, entrypoints : Entrypoints, shown : () => boolean) => {
    var inPortVessels = SArray<HomePagePortInPortVesselsData>([]),
        displayedInPortVessels = portFilterer(inPortVessels, i => i.PortName || ''),
        loader = maybeLoader(ajax, entrypoints.HomeInPort, inPortVessels, shown);

    return {
        Loading: loader.Loading,
        InPortVessels: displayedInPortVessels,
        Date: date
    };
};
export type InPortVessels = ReturnType<typeof InPortVessels>;


// WEBPACK FOOTER //
// ./apps/portcall/homepage/inport.ts